import React from "react";
import {useCore, useLogin} from "../hooks";
import './OrderDraftColumn.css'
import {Btn} from "./Btn.tsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router";

export const UserBox: React.FC = () => {
  const { core } = useCore()
  const { user, handleLogout } = useLogin()
  const navigate = useNavigate()

  return (
    <div className="flex flex-row items-center ml-auto">
      <div className="rounded-full bg-light-blue p-2 mr-2 w-9 h-9 flex items-center justify-center text-base-400"><FontAwesomeIcon icon={['far', 'user']} size="lg"/></div>
      <div>
        <div className="font-semibold text-md">
          {user.email}
        </div>
        <div className="text-xs text-base-400">
          {user.firstName} {user.lastName}
        </div>
      </div>
      <div className="tooltip tooltip-bottom" data-tip="Přepnout uživatele přes PIN">
        <Btn className={'btn-base-100 btn ml-2 2xl:ml-4'} icon={'fa-user-lock'} onClick={() => navigate('/login/pin')}></Btn>
      </div>
      <div className="tooltip tooltip-bottom" data-tip="Odhlásit se">
        <Btn className={'btn-base-100 btn ml-2 2xl:ml-4'} icon={'fa-right-from-bracket'} onClick={() => handleLogout(core)}></Btn>
      </div>
    </div>
  )
}
